import React, { useEffect, useState } from "react";
import { Link, useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import EditorViewer from "../Common/EditorViewer";
import FAQEditor from "./FAQEditor";
import RelationInfo from "../Common/RelationInfo";
import PopUp from "../Common/PopUp";
import { showToast } from "../Common/Messages";
import { parseToArray, parseToObject } from "../libs/Util";

const FAQ = (props) => {
    const {kind, faqID} = useParams();
    const LoginStates = useSelector(state => state.login);
    const [categoryList, setCategoryList] = useState([]);
    const [faqDataList, setfaqDataList] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [editPopup, setEditPopup] = useState();

    useEffect(() => {
        getCategoryList();
    }, []);

    useEffect(() => {
        if (kind) setSelectedCategory(kind);
    }, [kind]);

    useEffect(() => {
        if (selectedCategory !== null)
            searchFAQ();
    }, [selectedCategory]);
    useEffect(() => {
        if (!kind && categoryList && categoryList.length > 0) {
            setSelectedCategory("");
        }
    }, [categoryList]);

    const getCategoryList = async () => {
        const response = await fetch('/api/Document/GetFAQKindList', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
        const result = await response.json();
        if (response.status === 200 && result.data.table) {
            setCategoryList(result.data.table);
        }
    }

    const handleSearch = (e) => {
        if (e.key === "Enter" && !e.nativeEvent.isComposing) {
            e.preventDefault();
            searchFAQ();
        }
    }

    const searchFAQ = async () => {
        const category = selectedCategory ? selectedCategory : categoryList.map(x => x.faqKindName).join(",");
        try {
            const response = await fetch('/api/Document/GetFAQList', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    faqKindName: category,
                    searchText: searchText
                })
            });
            if (response.status === 200) {
                const result = await response.json();
                if (result.data.table) {
                    setfaqDataList(result.data.table);
                }
            }
        } catch (e) {
            showToast('danger', "정보를 조회할 수 없습니다. 잠시 후 다시 시도해주세요.");
        }
    }

    const handleEdit = (faq) => {
        // 임시 스타일
        const popupStyle = {
            // position: "relative",
            // margin: "auto", 
            // width: '900px'
        };
        setEditPopup(
            <div className='msg-popup center-box faq-write' style={popupStyle}>
                <div className='faq-box'>
                    <FAQEditor data={faq} setEditPopup={setEditPopup} EditFAQ={EditFAQ} categoryList={categoryList} />
                </div>
            </div>
        )
    }

    const handleDelete = async (faq) => {
        const isDelete = window.confirm("FAQ를 삭제하시겠습니까?");
        if (isDelete) {
            const result = await EditFAQ({ workingTag: "D", ...faq });
            if (result.status === 200) {
                showToast('success', "삭제되었습니다.");
            } else {
                showToast('danger', result.message);
            }
        }
    }

    const EditFAQ = async (data) => {
        const body = {
            ...data,
            devUserID: LoginStates.userId
        }
        const response = await fetch('/api/Document/EditFAQ', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.status === 200) searchFAQ();
        return { status: response.status, message: result.message };
    }

    const search = () => {
        return (
            <div className="search-section">
                <div className="search-input">
                    <i className="icoKdc24 magnifier-b"></i>
                    <input name="userPassword" placeholder="궁금한 사항을 검색해 보세요." onChange={(e) => setSearchText(e.target.value)} onKeyDown={handleSearch} />
                </div>
                {LoginStates.userRole.includes('Editor') && <button className="btn-write" onClick={() => handleEdit(null)}>글쓰기</button>}
            </div>

        )
    }

    const faqTab = () => {
        return (
            <ul className="faq-tab">
                <li className={selectedCategory === "" ? "selected" : ""} onClick={e => setSelectedCategory("")}>전체</li>
                {categoryList.map(category => {
                    return (
                        <li className={selectedCategory === category.faqKindName && "selected"} onClick={e => setSelectedCategory(category.faqKindName)}>{category.faqKindName}</li>
                    )
                })}
            </ul>
        )
    }

    const faqList = () => {
        return (
            <ul className="faq-list">
                {faqDataList.length === 0 ?
                    <div className="faq-empty">
                        <i className="icoKdc80 empty"></i>
                        <span>등록된 FAQ가 없습니다.</span>
                    </div>
                    :
                    faqDataList.map((faq, index) => {
                        return (
                            <FAQItem id={index} selectedId={faqID} faq={faq} handleEdit={handleEdit} handleDelete={handleDelete} selectedCategory={selectedCategory} />
                        )
                    })}
            </ul>
        )
    }

    return (
        <div className="container contents-wrapper">
            <div className="contents-wrapper-width faq">
                <h1 className="page-title">FAQ</h1>
                {search()}
                {faqTab()}
                {faqList()}
                <PopUp content={editPopup} setContent={() => { }} />
            </div>
        </div>
    );
}


const FAQItem = (props) => {
    const relationInfo = props.faq.relationInfo ? parseToArray(props.faq.relationInfo) : [];
    const answer = props.faq.answer ? parseToObject(props.faq.answer) : {};
    const tags = props.faq.tag ? parseToArray(props.faq.tag) : [];
    const LoginStates = useSelector(state => state.login);
    const [isOpen, setIsOpen] = useState(false);
    const [currentCategory, setCurrentCategory] = useState(props.selectedCategory);

    useEffect(() => {
        if(currentCategory !== props.selectedCategory) {
            setIsOpen(false);
        }
        setCurrentCategory(props.selectedCategory);
    }, [props.selectedCategory]);

    useEffect(() => {
        if (props.selectedId && props.selectedId === props.faq.faqID) {
            clickPostNode();
        }
    }, props.selectedId);

    const clickPostNode = (e, activate) => {

        if (isOpen)
            setIsOpen(false);
        else {
            setIsOpen(true);
            setTimeout(() => {
                const container = document.querySelector('.container');
                container.scrollTo({
                    top: document.getElementById(props.id).offsetTop - container.offsetTop,
                    behavior: 'smooth'
                });
            }, 100)
        }
    };
    return (<li id={props.id} className={`faq-list-each ${isOpen && "open"}`}>
        <Link onClick={(e) => clickPostNode(e)}>
            <div className="q-left">
                <p className="q-mark">Q</p>
                <div className="faq-title-wrap">
                    <p className="product-cate">{props.faq.faqKindName}</p>
                    <p className="faq-title">{props.faq.question}</p>
                </div>
            </div>
            <div className="ico-wrap">
                <i className="icoKdc20 seemore-m"></i>
            </div>
        </Link>
        <div className="answer">
            <div className="answer-top">
                <div className="answer-top-cnts">
                    <p className="a-mark">A</p>
                    <div className="answer-cnts-wrap">
                        <EditorViewer ViewMode={true} folderName={""} editorData={{ data: answer }} docId={props.faq.faqID} />
                        <div className="answer-tags">
                            {tags.map(tag => {
                                return (
                                    <p>{tag}</p>
                                )
                            })}
                        </div>
                    </div>
                </div>
                {LoginStates.userRole.includes('Editor') &&
                    <div className="btns-faqEdit">
                        <button onClick={e => props.handleEdit(props.faq)}><i className="icoKdc20 edit"></i></button>
                        <button onClick={e => props.handleDelete(props.faq)}><i className="icoKdc20 delete"></i></button>
                    </div>
                }
            </div>
            {relationInfo.length > 0 &&
                <RelationInfo relationInfo={relationInfo} />
            }

        </div>
    </li>
    );
}
export default FAQ;